import { Component, Input } from '@angular/core';
import { TextSizes, TextType } from '../../enums';
import { IonPageContainerComponent } from '../ion-page-container/ion-page-container.component';
import { IonPageContentComponent } from '../ion-page-container/ion-page-content/ion-page-content.component';
import { TextComponent } from '../text/text.component';
@Component({
  selector: 'app-coming-soon',
  templateUrl: './coming-soon.component.html',
  styleUrls: ['./coming-soon.component.scss'],
  imports: [IonPageContainerComponent, IonPageContentComponent, TextComponent],
})
export class ComingSoonComponent {
  @Input() public text = 'Раздел в разработке';

  public readonly TextSizes = TextSizes;

  public readonly TextType = TextType;
}
